import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/LoginPage'
import Films from '@/components/Films' // 确保你已创建此组件

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
    path: '/h5/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/h5/films',
    name: 'Films',
    component: Films
  }
  ]
})


export default router